import { defectTypeRequest } from '@/network/requests/defectType'
import { uploadDefectLevelXML, defectLevelRequest, deleteDefectLevel, EditFileFromContent } from '@/network/requests/defectLevel'
import seriousScrapped from '../SeriousScrapped'
import { jtCommandRequest } from '@/network/requests/jtCommand'

export default {
	data() {
		/**
		 * 重名检查
		 * @param {*} rule
		 * @param {*} value
		 * @param {*} callback
		 */
		var checkNameExist = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入配置名称'))
			} else {
				let exist = undefined
				if (this.form.id) {
					exist = this.tableData.find(t => t.name == this.form.name && t._id.$oid != this.form.id)
				} else {
					exist = this.tableData.find(t => t.name == this.form.name)
				}
				if (exist) {
					callback(new Error('配置名称已存在，请更换配置名称。'))
				} else {
					callback()
				}
			}
		}

		this.defectLevelObject = {
			name: '',
			unit: '',
			slightMin: 0,
			slightMax: 0,
			normalMin: 0,
			normalMax: 0,
			criticalMin: 0,
			criticalMax: 10000,
		}
		return {
			defectLevels: [],
			dialog_visible_config: false,
			dialog_visible_save: false,
			tableLoading: false,
			tableData: [],
			defectTypes: [],
			filteredDefectTypes: [],
			name: '',
			config_fileId: '',
			loading: false,
			titleDialog: '',
			disConfig: '',
			activeColor: false,
			saving: false,
			form: {
				name: '',
				id: '',
			},
			formRules: {
				name: [
					{ validator: checkNameExist, trigger: 'blur' },
					{ required: true, message: '请输入配置名称', trigger: 'blur' },
					{ min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' },
				],
			},
		}
	},
	props: {
		/**
		 * 机台Id。
		 */
		jt_id: {
			type: String,
		},
		/**
		 * 配置文件Id。
		 */
		file_id: {
			type: String,
		},
	},
	watch: {
		/**
		 * 通过文件加载配置。
		 */
		file_id(val) {
			this.config_fileId = val
			this.activeColor = false
		},
		/**
		 * 当前配置文件Id。
		 */
		config_fileId(val) {
			if (!val) {
				this.defectLevels = []
				return
			}
			this.getFileContent(val)
		},
	},
	computed: {
		/**
		 * 配置名称。
		 */
		configName() {
			if (this.config_fileId) {
				var td = this.tableData.find(t => t.file_id == this.config_fileId)
				if (td) return td.name
				return ''
			}
			return '未配置'
		},
	},
	methods: {
		/**
		 * 下发配置。
		 */
		distribution() {
			var cmd = 3
			jtCommandRequest
				.upload({
					jt_id: this.jt_id,
					cmd: cmd,
					is_set_cmd: 1,
					command_file_id: this.config_fileId,
					time: { $date: new Date().getTime() },
				})
				.then(res => {
					this.activeColor = false
					this.$message({
						message: '命令下发成功。',
						type: 'success',
					})
				})
				.finally(() => {})
		},
		/**
		 * 加载配置。
		 */
		loadConfig() {
			this.tableLoading = true
			defectLevelRequest
				.queryAll(undefined, undefined, { _id: -1 })
				.then(res => {
					this.tableData = res
				})
				.finally(() => {
					this.tableLoading = false
				})
		},
		/**
		 * 保存配置。
		 */
		save() {
			this.$refs['saveForm'].validate(valid => {
				if (valid) {
					if (!this.form.id) {
						this.handleSave()
						this.activeColor = false
					} else {
						this.changeName()
					}
				} else {
					console.log('error submit!!')
					return false
				}
			})

			this.name = ''
		},
		/**
		 * 修改配置。
		 */
		changeName() {
			this.saving = true
			EditFileFromContent(this.form.id, this.form.name)
				.then(res => {
					console.log('配置修改完成', res)

					this.loadConfig()
					this.$message({
						message: '名称修改成功',
						type: 'success',
					})
					this.dialog_visible_save = false
				})
				.catch(err => {
					this.$message.error('错误：' + err)
				})
				.finally(() => {
					this.saving = false
				})
		},
		/**
		 * 编辑名称
		 */
		handleEditConfig(row) {
			this.titleDialog = '编辑名称'
			this.dialog_visible_save = true
			this.form = {
				name: row.name,
				id: row._id.$oid,
			}
		},
		/**
		 * 获取缺陷等级配置XML。
		 */
		getFileContent(file_id) {
			console.log('getFileContent', file_id)
			this.loading = true
			defectLevelRequest
				.getFileContentById(file_id)
				.then(res => {
					console.log('配置内容\n', res.data)
					this.defectLevels = seriousScrapped.getDefectLevelFromXml(res.data)
				})
				.catch(err => {
					var msg = err
					if (err.toString().indexOf('404') > -1) {
						msg = '文件未找到'
					}
					this.$message.error(msg)
					this.defectLevels = []
				})
				.finally(() => {
					this.dialog_visible_config = false
					this.loading = false
				})
		},
		/**
		 * 添加缺陷级别。
		 */
		addDefectLevel() {
			this.defectLevels.push({ ...this.defectLevelObject })
		},
		/**
		 * 选择已有的缺陷配置。
		 */
		selectConfig() {
			this.dialog_visible_config = true
		},
		/**
		 * 过滤已选中的缺陷类型。
		 */
		filterDefectTypes(type) {
			var array = []
			this.defectTypes.forEach(v => {
				if (this.defectLevels.findIndex(t => t.name == v.name) == -1) {
					array.push(v)
				}
			})

			this.filteredDefectTypes = array
		},
		/**
		 * 删除一个缺陷级别。
		 */
		removeDefectLevel(item, index) {
			this.defectLevels.splice(index, 1)
		},
		/**
		 * 获取单位内容HTML。
		 */
		getUnitHtml(unit) {
			if (unit == 1) {
				return `mm<sup>2</sup>`
			}

			if (unit == 2) {
				return `mm`
			}

			return ''
		},
		/**
		 * 修改配置值时触发，控制严重值等于一般值的最大值。
		 */
		handleDefectLevelChange(val) {
			if (val.normalMin > val.criticalMin) {
				val.criticalMin = val.normalMin
			}
		},
		/**
		 * 另存为缺陷规则。
		 */
		saveAs() {
			this.form.name = ''
			this.form.id = ''
			this.titleDialog = '配置名称'
			this.dialog_visible_save = true
		},
		/**
		 * 修改缺陷等级配置。
		 */
		updateRule() {
			console.log('保存信息修改')

			if (!this.config_fileId) {
				return
			}

			var xml = seriousScrapped.saveDefectLevel(this.defectLevels)

			//保存缺陷等级。
			uploadDefectLevelXML(xml, this.form.name, this.config_fileId)
				.then(res => {
					this.$message({
						message: '配置修改成功。',
						type: 'success',
					})
					this.loadConfig()
				})
				.catch(err => {
					this.$message.error('修改失败：' + err)
				})
				.finally(() => {
					this.dialog_visible_save = false
				})
		},
		/**
		 * 保存缺陷等级。
		 */
		handleSave() {
			this.saving = true
			var xml = seriousScrapped.saveDefectLevel(this.defectLevels)
			console.log('保存缺陷等级', xml)
			//保存缺陷等级。
			uploadDefectLevelXML(xml, this.form.name)
				.then(res => {
					this.config_fileId = res
					this.$message({
						type: 'success',
						message: '配置成功',
					})
					this.loadConfig()
				})
				.finally(() => {
					this.dialog_visible_save = false
					this.saving = false
				})
		},
		/**
		 * 选择配置。
		 */
		handleSelectConfig(row) {
			this.activeColor = true
			this.config_fileId = row.file_id

			// this.configName = row.name
			this.dialog_visible_config = false
		},
		/**
		 * 查看配置内容。
		 */
		handleViewContent() {},
		/**
		 * 删除配置。
		 */
		handleDeleteConfig(row) {
			deleteDefectLevel(row._id.$oid, row.file_id)
				.then(res => {
					console.log('删除配置', res)
				})
				.finally(() => {
					this.loadConfig()
				})
		},
	},
	async created() {
		this.config_fileId = this.file_id
		this.loadConfig()

		//获取所有缺陷类型。
		this.defectTypes = await defectTypeRequest.queryAll({ roll_id: 'sys' })
	},
}
